import { css, type SerializedStyles } from '@emotion/react';

import { KAI_SHIKI_LAYOUT, KAI_SHIKI_TYPOGRAPHY, styleguideColors as COLORS } from '@/Client/Styles/kaiShikiTokens';

/** Every style the floor plan editor demo draws with. */
export type FloorPlanEditorDemoStyles = {
  root: SerializedStyles;
  toolbar: SerializedStyles;
  viewSwitch: SerializedStyles;
  viewOption: SerializedStyles;
  viewOptionSelected: SerializedStyles;
  backButton: SerializedStyles;
  roomName: SerializedStyles;
  note: SerializedStyles;
  editorHost: SerializedStyles;
};

/** The demo's default look: a toolbar with the view switch and a note, above the editor. */
export const DEFAULT_FLOOR_PLAN_EDITOR_DEMO_STYLES: FloorPlanEditorDemoStyles = {
  root: css`
    label: FLOOR_PLAN_EDITOR_DEMO_STYLE;
    display: flex;
    flex-direction: column;
    height: 100%;
    min-height: 0;
  `,
  toolbar: css`
    label: FLOOR_PLAN_EDITOR_DEMO_TOOLBAR_STYLE;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: ${KAI_SHIKI_LAYOUT.spacing2}px;
    padding: ${KAI_SHIKI_LAYOUT.spacing1}px ${KAI_SHIKI_LAYOUT.spacing2}px;
    background: ${COLORS.paper};
    border-bottom: 1px solid ${COLORS.stroke};
  `,
  viewSwitch: css`
    label: FLOOR_PLAN_EDITOR_DEMO_VIEW_SWITCH_STYLE;
    display: inline-flex;
    align-items: stretch;
    border: 1px solid ${COLORS.stroke};
    background: ${COLORS.white};
  `,
  viewOption: css`
    label: FLOOR_PLAN_EDITOR_DEMO_VIEW_OPTION_STYLE;
    ${KAI_SHIKI_TYPOGRAPHY.xSmallBold}
    padding: ${KAI_SHIKI_LAYOUT.spacingHalf}px ${KAI_SHIKI_LAYOUT.spacing1p5}px;
    border: 0;
    border-left: 1px solid ${COLORS.stroke};
    background: transparent;
    color: ${COLORS.midtone};
    text-transform: uppercase;
    cursor: pointer;
  
    &:first-of-type {
      border-left: 0;
    }
  
    &:hover {
      color: ${COLORS.ink};
    }
  `,
  viewOptionSelected: css`
    label: FLOOR_PLAN_EDITOR_DEMO_VIEW_OPTION_SELECTED_STYLE;
    background: ${COLORS.ink};
    color: ${COLORS.white};
    cursor: default;
  
    &:hover {
      color: ${COLORS.white};
    }
  `,
  backButton: css`
    label: FLOOR_PLAN_EDITOR_DEMO_BACK_BUTTON_STYLE;
    ${KAI_SHIKI_TYPOGRAPHY.smallBold}
    padding: ${KAI_SHIKI_LAYOUT.spacingHalf}px ${KAI_SHIKI_LAYOUT.spacing1}px;
    border: 1px solid ${COLORS.stroke};
    background: ${COLORS.white};
    color: ${COLORS.ink};
    cursor: pointer;
  `,
  roomName: css`
    label: FLOOR_PLAN_EDITOR_DEMO_ROOM_NAME_STYLE;
    ${KAI_SHIKI_TYPOGRAPHY.mediumBold}
    color: ${COLORS.ink};
  `,
  note: css`
    label: FLOOR_PLAN_EDITOR_DEMO_NOTE_STYLE;
    ${KAI_SHIKI_TYPOGRAPHY.small}
    color: ${COLORS.midtone};
  `,
  editorHost: css`
    label: FLOOR_PLAN_EDITOR_DEMO_EDITOR_HOST_STYLE;
    flex: 1;
    min-height: 0;
    min-width: 0;
    display: flex;
  `,
};
